/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { OverviewSlidingWindow } from '#PRIVATE_VisOverview';
import { OverviewBackground } from '#PRIVATE_VisOverview/OverviewBackground';
import { updateViewportFromOverview } from '#utils/PRIVATE_chartUtils/overviewUtils';
import { Scale } from '#utils/UNSAFE_visTypes/chart';
import { Dimension } from '#utils/UNSAFE_visTypes/common';

export function getRenderer(
  xAxisExtent: { min: number; max: number },
  isRtl: boolean,
  overviewXScale: Scale,
  plotAreaSpace: Dimension,
  windowCoords: { windowX: number; windowY: number; windowHeight: number; windowWidth: number },
  hasHandles: boolean,
  onViewportChange?: (detail: {
    xMin?: number;
    xMax?: number;
    yMin?: number;
    yMax?: number;
  }) => void
) {
  return {
    slidingWindow: (
      <OverviewSlidingWindow
        {...plotAreaSpace}
        {...windowCoords}
        hasHandles={hasHandles}
        onWindowDimsChange={(props: { deltaX: number; deltaWidth: number }) => {
          updateViewportFromOverview(
            xAxisExtent,
            isRtl,
            windowCoords.windowX,
            windowCoords.windowWidth,
            props.deltaX,
            props.deltaWidth,
            overviewXScale,
            onViewportChange
          );
        }}
      />
    ),
    background: <OverviewBackground {...plotAreaSpace} {...windowCoords} />
  };
}
